function ImageElement({ element }) {
  const { style, url } = element;

  return <img src={url} width={style.width} height={style.height} alt="Creative element" />;
}

export default ImageElement;
